export default __webpack_public_path__ + "static/media/damaged.bf81fc74.svg";